import { render, staticRenderFns } from "./UpdateAddress.vue?vue&type=template&id=d6b4f6ec"
import script from "./UpdateAddress.vue?vue&type=script&lang=ts"
export * from "./UpdateAddress.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports